import { BILLING_CYCLE } from '@/common/constants';
import { translation } from '@/plugins/i18n';

export const planUnitMap = {
  user: 0,
  license: 1,
  attendee: 2,
  room: 3,
  port: 4,
  account: 4,
  membership: 5,
  credits: 6,
  number: 7,
  space: 8,
};

export const getPlanUnitWithCycle = (billingCycle = '', type = planUnitMap.user) => {
  if (type === planUnitMap.user) {
    switch (billingCycle) {
      case BILLING_CYCLE.ANNUAL:
        return translation('billing.common.per_billing_cycle_user.annual');
      case BILLING_CYCLE.MONTHLY:
        return translation('billing.common.per_billing_cycle_user.monthly');
      case BILLING_CYCLE.ONE_MONTH:
      case BILLING_CYCLE.ONE_TIME:
        return translation('billing.common.per_billing_cycle_user.one_month');
      case BILLING_CYCLE.QUARTERLY:
        return translation('billing.common.per_billing_cycle_user.quarterly');
      case BILLING_CYCLE.TWO_YEARS:
        return translation('billing.common.per_billing_cycle_user.two_years');
      case BILLING_CYCLE.THREE_YEARS:
        return translation('billing.common.per_billing_cycle_user.three_years');
      default:
        return "";
    }
  } else if (type === planUnitMap.license) {
    switch (billingCycle) {
      case BILLING_CYCLE.ANNUAL:
        return translation('billing.common.per_billing_cycle_license.annual');
      case BILLING_CYCLE.MONTHLY:
        return translation('billing.common.per_billing_cycle_license.monthly');
      case BILLING_CYCLE.ONE_MONTH:
      case BILLING_CYCLE.ONE_TIME:
        return translation('billing.common.per_billing_cycle_license.one_month');
      case BILLING_CYCLE.QUARTERLY:
        return translation('billing.common.per_billing_cycle_license.quarterly');
      case BILLING_CYCLE.TWO_YEARS:
        return translation('billing.common.per_billing_cycle_license.two_years');
      case BILLING_CYCLE.THREE_YEARS:
        return translation('billing.common.per_billing_cycle_license.three_years');
      default:
        return "";
    }
  } else if (type === planUnitMap.room) {
    switch (billingCycle) {
      case BILLING_CYCLE.ANNUAL:
        return translation('billing.common.per_billing_cycle_room.annual');
      case BILLING_CYCLE.MONTHLY:
        return translation('billing.common.per_billing_cycle_room.monthly');
      case BILLING_CYCLE.ONE_MONTH:
        return translation('billing.common.per_billing_cycle_room.one_month');
      case BILLING_CYCLE.QUARTERLY:
        return translation('billing.common.per_billing_cycle_room.quarterly');
      case BILLING_CYCLE.TWO_YEARS:
        return translation('billing.common.per_billing_cycle_room.two_years');
      case BILLING_CYCLE.THREE_YEARS:
        return translation('billing.common.per_billing_cycle_room.three_years');
      default:
        return "";
    }
  } else if (type === planUnitMap.port) {
    switch (billingCycle) {
      case BILLING_CYCLE.ANNUAL:
        return translation('billing.common.per_billing_cycle_port.annual');
      case BILLING_CYCLE.MONTHLY:
        return translation('billing.common.per_billing_cycle_port.monthly');
      case BILLING_CYCLE.ONE_MONTH:
        return translation('billing.common.per_billing_cycle_port.one_month');
      case BILLING_CYCLE.QUARTERLY:
        return translation('billing.common.per_billing_cycle_port.quarterly');
      case BILLING_CYCLE.TWO_YEARS:
        return translation('billing.common.per_billing_cycle_port.two_years');
      case BILLING_CYCLE.THREE_YEARS:
        return translation('billing.common.per_billing_cycle_port.three_years');
      default:
        return "";
    }
  } else if (type === planUnitMap.credits) {
    switch (billingCycle) {
      case BILLING_CYCLE.ANNUAL:
        return translation('billing.common.per_billing_cycle.annual');
      case BILLING_CYCLE.QUARTERLY:
        return translation('billing.common.per_billing_cycle.quarterly');
      case BILLING_CYCLE.TWO_YEARS:
        return translation('billing.common.per_billing_cycle.two_years');
      case BILLING_CYCLE.THREE_YEARS:
        return translation('billing.common.per_billing_cycle.three_years');
      case BILLING_CYCLE.MONTHLY:
      case BILLING_CYCLE.ONE_MONTH:
      default:
        return translation('billing.common.per_billing_cycle.monthly');
    }
  } else if (type === planUnitMap.number) {
    switch (billingCycle) {
      case BILLING_CYCLE.ANNUAL:
        return translation('billing.common.per_billing_cycle_number.annual');
      case BILLING_CYCLE.MONTHLY:
        return translation('billing.common.per_billing_cycle_number.monthly');
      case BILLING_CYCLE.ONE_MONTH:
        return translation('billing.common.per_billing_cycle_number.one_month');
      case BILLING_CYCLE.QUARTERLY:
        return translation('billing.common.per_billing_cycle_number.quarterly');
      case BILLING_CYCLE.TWO_YEARS:
        return translation('billing.common.per_billing_cycle_number.two_years');
      case BILLING_CYCLE.THREE_YEARS:
        return translation('billing.common.per_billing_cycle_number.three_years');
      default:
        return "";
    }
  } else if (type === planUnitMap.space) {
    switch (billingCycle) {
      case BILLING_CYCLE.ANNUAL:
        return translation('billing.common.per_billing_cycle_space.annual');
      case BILLING_CYCLE.MONTHLY:
        return translation('billing.common.per_billing_cycle_space.monthly');
      default:
        return "";
    }
  }

  return '';
};

// Only need show monthly text
export const getDiscountedMonthPlanUnit = (type = planUnitMap.user) => {
  switch (type) {
    case planUnitMap.user:
      return translation('billing.common.per_billing_cycle_user.monthly');
    case planUnitMap.license:
      return translation('billing.common.per_billing_cycle_license.monthly');
    case planUnitMap.room:
      return translation('billing.common.per_billing_cycle_room.monthly');
    case planUnitMap.port:
      return translation('billing.common.per_billing_cycle_port.monthly');
    case planUnitMap.credits:
      return translation('billing.common.per_billing_cycle.monthly');
    case planUnitMap.number:
      return translation('billing.common.per_billing_cycle_number.monthly');
    case planUnitMap.space:
      return translation('billing.common.per_billing_cycle_space.monthly');
    default:
      return ''
  }
};
export const getPlanUnitWithQuantity = (type = planUnitMap.user) => {
  switch (type) {
    case planUnitMap.license:
      return translation('billing.planform.unit.license');
    case planUnitMap.user:
      return translation('billing.planform.unit.user');
    case planUnitMap.room:
      return translation('billing.planform.unit.room');
    case planUnitMap.port:
      return translation('billing.planform.unit.port');
    case planUnitMap.account:
      return translation('billing.planform.unit.account');
    case planUnitMap.membership:
      return translation('billing.planform.unit.membership');
    case planUnitMap.credits:
      return translation('billing.planform.unit.credits');
    case planUnitMap.number:
      return translation('billing.planform.unit.number');
    case planUnitMap.space:
      return translation('billing.planform.unit.space');
    default:
      return "";
  }
}
